import type { BrandTokens } from '@hub/common';

// CSS custom properties protocol CSS reads, e.g. `var(--brand-primary, #3f51b5)`.
export const brandCssVariables = (
  tokens: BrandTokens | undefined
): Record<string, string> =>
  tokens
    ? {
        '--brand-primary': tokens.primary,
        '--brand-secondary': tokens.secondary,
        '--brand-background': tokens.background,
        '--brand-surface': tokens.surface,
        '--brand-text': tokens.text,
        '--brand-radius': `${tokens.radius.toString()}px`,
      }
    : {};
